export enum CustomerTab {
  Contract = 'contract',
  Products = 'products',
  Pricing = 'pricing',
  Billing = 'billing',
  AuditLogs = 'audit-logs',
}
